module.exports = __webpack_public_path__ + "img/pic_special6.f5716802.png";